import Translate from "../../Context/Translate";

import { useEffect, useState } from "react";
import logo from "../../assets/images/1.png";
import { Container } from "../../components";
import { toScroll } from "../../Context/functions";
import { content } from "../../lang/useLang";
import "./link.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // حالة القائمة الموبايل

  const links = [
    { scroll: 0, id: 0, name: content.home },
    { scroll: 1060, id: 1, name: content.about_us },
    { scroll: 2000, id: 2, name: content.products },
    { scroll: 4200, id: 3, name: content.services },
    { scroll: 5100, id: 4, name: content.partners },
    { scroll: 6250, id: 5, name: content.contact_us },
  ];
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;

      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      let current = 0;
      for (let i = 0; i < links.length; i++) {
        if (scrollY >= links[i].scroll) current = links[i].id;
      }

      setActiveLink(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // تتبع التمرير لتغيير مظهر النافبار
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY >= 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = (nav) => {
    setActiveLink(nav.id);
    toScroll(nav.scroll);
    setIsMobileMenuOpen(false); // إغلاق القائمة عند النقر على رابط
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 transition-all py-1 duration-500 ${
        isScrolled
          ? "bg-slate-900/95 backdrop-blur-xl shadow-2xl "
          : "bg-transparent backdrop-blur-xl"
      } `}
    >
      <Container>
        <div className="flex justify-between items-center">
          {/* الشعار مع تأثيرات */}
          <div
            className="font-bold text-2xl text-white logo flex items-center cursor-pointer group"
            onClick={() => toScroll(0)}
          >
            <img src={logo} alt="" className="w-24" />
            {/* تأثير نقطة تحت الشعار */}
            <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-Main group-hover:w-full transition-all duration-500 rounded-full"></div>
          </div>

          {/* زر الترجمة مع تأثيرات */}
          <div className="relative group flex gap-5 ">
            <Translate />
            {/* تأثير خلفية للزر */}
            <div className="absolute -inset-2 bg-Main/10 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <button
              className="lg:hidden text-white p-2 rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-Main/20 transition-all duration-300"
              onClick={toggleMobileMenu}
            >
              {isMobileMenuOpen ? (
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* زر القائمة للموبايل */}
        </div>

        {/* قائمة الموبايل المنزلقة */}
        <div
          className={`lg:hidden fixed top-full left-0 right-0 bg-slate-900/95 backdrop-blur-xl shadow-2xl transition-all duration-500  ${
            isMobileMenuOpen
              ? "max-h- opacity-100 translate-y-0"
              : "max-h-0 opacity-0 hidden -translate-y-4"
          }`}
        >
          <div className="py-4 px-4">
            <ul className="flex flex-col gap-4 text-white">
              {links.map((link, index) => (
                <li
                  key={index}
                  className={`relative group py-3 px-4 rounded-lg transition-all duration-300 cursor-pointer ${
                    activeLink === link.id
                      ? "bg-Main/20 text-Main scale-[1.02]"
                      : "text-white/80 hover:bg-white/10 hover:text-Main/90"
                  }`}
                  onClick={() => handleLinkClick(link)}
                >
                  <div className="flex items-center justify-between">
                    <span className="relative z-10 font-medium">
                      {link.name}
                    </span>
                    {activeLink === link.id && (
                      <div className="w-2 h-2 bg-Main rounded-full animate-pulse"></div>
                    )}
                  </div>

                  {/* تأثير الخلفية عند التحويم */}
                  <div className="absolute inset-0 bg-Main/10 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>

      {/* خط تقدم تفاعلي */}
      <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-Main/50 to-transparent">
        <div
          className="h-full bg-Main transition-all duration-300 ease-out"
          style={{
            width: `${scrollProgress}%`,
          }}
        ></div>
      </div>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes navSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes linkPulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
        .nav-item {
          animation: navSlideIn 0.6s ease-out forwards;
          opacity: 0;
        }
        .nav-item:nth-child(1) {
          animation-delay: 0.1s;
        }
        .nav-item:nth-child(2) {
          animation-delay: 0.2s;
        }
        .nav-item:nth-child(3) {
          animation-delay: 0.3s;
        }
        .nav-item:nth-child(4) {
          animation-delay: 0.4s;
        }
        .nav-item:nth-child(5) {
          animation-delay: 0.5s;
        }
        .nav-item:nth-child(6) {
          animation-delay: 0.6s;
        }

        .active-link {
          animation: linkPulse 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Navbar;
